import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../component/Layout";
import SubLayout from "../component/SubLayout";
import classes from "./SubscribePage.module.css";
import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { FaCheck, FaCopyright } from "react-icons/fa6";
import { v4 as uuidv4 } from "uuid";
import SmallLoader from "../component/SmallLoader";
import Header from "../component/Header";
import Container from "../component/Container";
import { subApi } from "../http/http";
import { setUserDetails } from "../store/slices/userSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import VideoSrc from "../assets/add.mp4";
import TermsModal from "../component/TermsModal";

const SubscribePage = () => {
  const [msisdn, setMsisdn] = useState("");
  const [loading, setLoading] = useState(false);
  const [extRef, setExtRef] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  const [selectedPack, setSelectedPack] = useState("Daily");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state?.persisted?.userSlice);

  const [termsModal, setTermsModal] = useState(false);

  const [alias, setAlias] = useState(localStorage.getItem("ugAlias"));
  const [phone, setPhone] = useState("");
  const [uniqueId, setUniqueId] = useState("");
  const [subMode, setSubMode] = useState("WAP");
  const serviceId = 1;

  useEffect(() => {
    if (userDetails?.token) {
      navigate("/home");
    }
  }, [userDetails]);

  useEffect(() => {
    if (searchParams.get("ext_ref")) {
      setExtRef(searchParams.get("ext_ref"));
    } else {
      setSearchParams({ ext_ref: uuidv4() });
    }
  }, [searchParams]);

  useEffect(() => {
    if (searchParams.get("uid")) {
      setUniqueId(searchParams.get("uid"));
      setSubMode("APP");
      console.log("alias=" + alias + ":" + uniqueId);
    } else {
      setUniqueId(Random());
      console.log("alias=" + alias + "::" + uniqueId);
    }
    if (alias) {
      setPhone("0");
      setLoading(true);
      subApi({ action: 0, ani: phone, serviceId: serviceId, alias: alias })
        .then((res) => {
          console.log(res);
          if (res.data.data !== null && res.data.data !== undefined) {
            setLoading(false);
            dispatch(setUserDetails(res?.data?.data));
            window.location.href = "/home";
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          navigate("/select-subscription", { state: { alias: alias } });
        });
    }
  }, []);

  const Random = () => {
    let rnd = Math.floor(Math.random() * 90000) + 10000;
    return rnd + "" + Date.now();
  };

  const handleFormSubmission = async (e) => {
    e.preventDefault();

    try {
      if (msisdn?.trim().length < 9) {
        return;
      }
      setLoading(true);

      const response = await subApi({ action: 3, serviceId: 1, ani: msisdn });
      // console.log(response, 'response');
      //dispatch(setUserDetails(response?.data));
      setLoading(false);
      // toast.success("Login Successfully!");
      navigate("/otp", { state: { msisdn, otpId: response?.data?.data } });
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message ||
          error?.response?.message ||
          error?.data?.message ||
          "Something Went Wrong!",
      );
    }
  };

  return (
    <Layout>
      <SubLayout>
        <Header hide={true} />
        <Container>
          <h1 className={classes.heading}>
            {t("1")}
            <span className={classes.highlight}>{t("0")}</span>
            {t("2")}
          </h1>
          <div className={classes.check_box_container}>
            <video
              src={VideoSrc}
              autoPlay
              loop
              muted
              playsInline
              style={{ width: "100%", height: "auto" }}
            />
          </div>

          <form className={classes.form} onSubmit={handleFormSubmission}>
            <div className={classes.username_field_form}>
              <div className={classes.country_code}>
                <img
                  src="/assets/images/cameroon.png"
                  alt="flag"
                  className={classes.flag}
                />
                <p className={classes.country_code_number}>+237</p>
              </div>
              <input
                id="msisdn"
                name="msisdn"
                type="number"
                onWheel={(e) => e.target.blur()}
                autoFocus
                placeholder={t("3")}
                className={classes.input_field_username}
                onChange={(e) => {
                  setMsisdn(e.target.value);
                }}
                value={msisdn}
              />
            </div>
            <div className={classes.check_box_container}>
              <input
                type="checkbox"
                id="terms"
                name="Terms & Conditions"
                value="Terms"
                className={classes.check_box}
                checked
              ></input>
              <label for="terms" className={classes.check_box_label}>
                {t("4")}{" "}
                <span
                  className={classes.terms_conditions}
                  onClick={() => setTermsModal(true)}
                >
                  {t("5")}
                </span>
              </label>
            </div>
            <button
              type="submit"
              disabled={loading}
              className={classes.login_btn}
            >
              {loading ? (
                <SmallLoader style={{ border: "5px solid #fff" }} />
              ) : (
                t("6")
              )}
            </button>
          </form>

          {/* <div>
            <p className={classes.stopSub}>{t("stop_sub")}</p>
          </div> */}
          <div className={classes.footer_container}>
            <FaCopyright className={classes.copyright_icon} />
            <p className={classes.copyright_text}>{t("7")}</p>
          </div>
        </Container>
        {termsModal && <TermsModal setTermsModal={setTermsModal} />}
      </SubLayout>
    </Layout>
  );
};

export default SubscribePage;
